import { render, staticRenderFns } from "./sound.vue?vue&type=template&id=b9469592&scoped=true&"
var script = {}
import style0 from "./sound.vue?vue&type=style&index=0&id=b9469592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9469592",
  null
  
)

export default component.exports